import React, { useState } from "react";
import { LiveClassIcon } from "../../../core/common/icons/icons";
import LiveClassModal from "../../../core/components/LiveClassModal";
import { useHandleCourses } from "../../../core/hooks/useHandleCourses";
import {
  convertTimestampToDate,
} from "../../../core/common/ults/dateTime";
import { useTranslation } from "react-i18next";

const LiveClassCard = ({ activity, courseId}: any) => {
  const {t} = useTranslation()
  const [showModal, setShowModal] = useState(false);
  const { courseDetails } = useHandleCourses(courseId);

  const getStatusBadge = () => {
    const status = activity?.status?.value;
    let badge = null;
    switch (status) {
      case "in_progress":
        badge = (
          <>
            <span className="badge bg-success">
              <i className="isax isax-video me-1" />
              {t(`liveClasses.card.status.${status}`)}
            </span>
            {activity?.status?.started_at !== 0 && (
              <span className="badge bg-success">
                <i className="isax isax-video me-1" />
                {convertTimestampToDate(activity?.status?.started_at)}
              </span>
            )}
          </>
        );
        break;
      case "waiting_for_moderator":
        badge = (
          <span className="badge bg-warning">
            <i className="isax isax-clock me-1" />
            {t(`liveClasses.card.status.${status}`)}
          </span>
        );
        break;
      case "room_ready":
        badge = (
          <span className="badge bg-primary">
            <i className="isax isax-tick-circle me-1" />
            {t(`liveClasses.card.status.${status}`)}
          </span>
        );
        break;
      case "ended":
        badge = (
          <span className="badge bg-secondary">
            <i className="isax isax-close-circle me-1" />
            {t(`liveClasses.card.status.${status}`)}
          </span>
        );
        break;
      case "not_started":
        badge = (
          <span className="badge bg-info">
            <i className="isax isax-timer me-1" />
            {t(`liveClasses.card.status.${status}`)}
          </span>
        );
        break;
      default:
        badge = null;
        break;
    }
    return badge;
  };

  return (
    <>
      <div className="card live-class-card-compact mb-3">
        <div className="card-body p-3">
          <div className="d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center flex-grow-1">
              <LiveClassIcon className="text-danger fs-24 me-3" />
              <div className="flex-grow-1">
                <h6 className="mb-1">{activity.name}</h6>
                <small className="text-muted">
                  {courseDetails?.courses[0]?.fullname}
                </small>
                <div className="mt-1">
                  {getStatusBadge()}
                  <span className="badge bg-light text-dark ms-2">
                    {activity.participant_count} {t(`liveClasses.card.participants`)}
                  </span>
                </div>
              </div>
            </div>
            <div className="d-flex gap-2">
              <button
                className="btn btn-sm btn-outline-primary"
                onClick={() => setShowModal(true)}
              >
                {t(`liveClasses.card.buttons.details`)}
              </button>
            </div>
          </div>
        </div>
      </div>
      {showModal && (
        <LiveClassModal
          isOpen={showModal}
          onClose={() => setShowModal(false)}
          bigBlueButtonActivity={activity}
          courseDetails={courseDetails}
        />
      )}
    </>
  );
};

export default LiveClassCard;
